import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetTipoBico() {
  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_TIPO_BICO_DROPDOWN_ID_EXTERNO],
    async () => {
      const { data } = await http.get(URL.PLANO_OPERACIONAL.OBTER_TIPO_BICO_DROPDOWN_ID_EXTERNO);
      return data;
    }
  );
}

export default useGetTipoBico;
